module.exports = __webpack_public_path__ + "static/media/dictionaryEmployees.0068df73.svg";